import { ChangeEvent, ComponentProps } from 'react'

import { Box, Button, SearchField, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CycleFilter } from 'modules/performance_cycles/components/CycleFilter'

interface Props {
  cycleFilterProps: ComponentProps<typeof CycleFilter>
  createMetricGroup: { can: boolean; onClick: () => void }
  manageCycles: { can: boolean; onClick: () => void }
  search: { value: string; onChange: (event: ChangeEvent<HTMLInputElement>) => void }
  onlyDirectReports?: { value: boolean; onChange: (value: boolean) => void }
}

export const TableHeader: React.FC<Props> = ({
  cycleFilterProps,
  createMetricGroup,
  manageCycles,
  search,
  onlyDirectReports,
}) => (
  <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
    <Box flexDirection="row" alignItems="center" gap="s12">
      <CycleFilter {...cycleFilterProps} />
      {onlyDirectReports && (
        <TogglerCheckbox
          label={i18n.t('performance_goals.employee_list.only_direct_reports')}
          value={onlyDirectReports.value}
          onChange={onlyDirectReports.onChange}
        />
      )}
    </Box>
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box maxWidth="s200">
        <SearchField
          placeholder={i18n.t('common.search_by')}
          search={search.value}
          onSearch={search.onChange}
        />
      </Box>
      {manageCycles.can && (
        <Button type="secondary" onClick={manageCycles.onClick}>
          {i18n.t('performance_goals.cycles.manage_cycles')}
        </Button>
      )}
      {createMetricGroup.can && (
        <Button type="primary" onClick={createMetricGroup.onClick} iconName="add">
          {i18n.t('performance_goals.goal_list.create_button')}
        </Button>
      )}
    </Box>
  </Box>
)
